import { Checkbox } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const AutocompleteOption = ({
  multiple,
  option,
  selected,
  OptionProps,
  ...rest
}) => {
  return multiple ? (
    <li data-testid="Autocomplete.Option" {...rest}>
      <Checkbox
        icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
        checkedIcon={<CheckBoxIcon fontSize="small" />}
        sx={{ mr: 0 }}
        checked={selected}
      />
      {option.label}
    </li>
  ) : (
    <li data-testid="Autocomplete.Option" {...OptionProps} {...rest}>
      {option.label}
    </li>
  );
};
export default AutocompleteOption;
